import { Alert } from 'braid-design-system';

import { CreditHoldBody } from './components/CreditHoldBody';

interface Props {
  renderAlert?: boolean;
  userCanPayInvoices: boolean;
  onHandleOutstandingClick: () => void;
}

export const CreditHold = (props: Props) =>
  props.renderAlert ? (
    <Alert tone="critical">
      <CreditHoldBody {...props} />
    </Alert>
  ) : (
    <CreditHoldBody {...props} />
  );
